/**
* @file 公共组件--登录输入框
* */
<template>
  <div id="loginInput">
    <label class="login-label" :for="forId" :class="{'input-focus': focus || content, 'color': focus}">{{placeholder}}</label>
    <input :type="type" :id="forId" v-model="content" :maxlength="maxlength"
           size="mini" class="input-inner" :class="{'input-inner-focus': focus || content}"
           @focus="focusFn()" @blur="blurFn" @input="inputFn">
  </div>
</template>

<script>
  export default {
    name: 'loginInput',
    // model: {
    //   prop: 'value',
    //   event: 'inputFn'
    // },
    props: {
      // 输入框label
      placeholder: {
        default () {
          return ''
        }
      },
      // for及id唯一标识符--同一个表单不能有两个相同的标识符
      forId: {
        default () {
          return 'xkinput'
        }
      },
      // 长度限制
      maxlength: {
        default () {
          return 11
        }
      },
      // 输入框类型
      type: {
        default () {
          return 'text'
        }
      },
      // 输入框类型
      value: {
        default () {
          return ''
        }
      }
    },
    watch: {
      value (val) {
        this.content = val;
        
      }
    },
    data () {
      return {
        // 输入框内容
        content: '',
        // 是否聚焦
        focus: false
      }
    },
    methods: {
      /**
       * 输入框聚焦
       */
      focusFn () {
        this.focus = true;
        this.$emit('focusFn', this.content)
      },
      /**
       * 输入框失焦
       */
      blurFn () {
        this.focus = false;
        this.$emit('blurFn', this.content)
      },
      /**
       * 输入框聚焦
       */
      inputFn () {
        this.$emit('update:value', this.content)
      }
    },
    mounted () {
    }
  }
</script>

<style lang="less">
  #loginInput {
    width: 100%;
    position: relative;
    margin-bottom: 12px;

    .login-label{
      position: absolute;
      left: 16px;
      top: 50%;
      color: rgba(60, 60, 67, 0.45);
      transform: translateY(-10%);
      font-size: 16px;
      font-weight: 400;
      letter-spacing: -0.2px;
      // iOS 26 流畅弹性动画
      transition: 
        transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        font-size 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        color 0.3s ease,
        font-weight 0.3s ease;
      pointer-events: none;
    }

    .input-inner {
      width: 100%;
      height: 44px;
      font-size: 16px;
      border: 1px solid rgba(0, 0, 0, 0.04);
      box-sizing: border-box;
      padding: 0 16px;
      padding-right: 100%;
      margin-top: 18px;
      background: rgba(255, 255, 255, 0.95);
      // iOS 26 柔和多层阴影
      box-shadow: 
        0 1px 2px rgba(0, 0, 0, 0.04),
        0 2px 8px rgba(0, 0, 0, 0.04),
        0 4px 16px rgba(0, 0, 0, 0.02);
      // iOS 26 圆润圆角
      border-radius: 12px;
      // 流畅弹性过渡
      transition: 
        box-shadow 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        border-color 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        background 0.35s ease;
      
      &:focus {
        padding-right: 16px;
        outline: none;
        border-color: fade(@color-primary, 30%);
        background: #fff;
        // 聚焦时增强阴影层次
        box-shadow: 
          0 1px 2px rgba(0, 0, 0, 0.04),
          0 4px 12px rgba(0, 0, 0, 0.06),
          0 0 0 3px fade(@color-primary, 12%);
        transform: translateY(-1px);
      }

      &:hover:not(:focus) {
        border-color: rgba(0, 0, 0, 0.08);
        box-shadow: 
          0 1px 3px rgba(0, 0, 0, 0.05),
          0 3px 10px rgba(0, 0, 0, 0.05),
          0 6px 20px rgba(0, 0, 0, 0.03);
      }
    }

    .input-inner-focus{
      padding-right: 16px;
    }

    .input-inner:-webkit-autofill {
      -webkit-text-fill-color: #222222 !important;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
      -webkit-transition-delay: 99999s;
      -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
    }
    .input-inner:-internal-autofill-selected{
      bottom: 31px;
      /*font-size: 14px;*/
      font-size: 16px;
      font-weight: 400;
      line-height: 16px;
      transition: all linear 0.3s;
    }
    .input-inner:-webkit-autofill {
      -webkit-text-fill-color: #141A33 !important;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
      transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
    }

    .input-focus{
      top: -5px;
      font-size: 14px;
      font-weight: 500;
      transform: translateY(0);
    }

    .color{
      color: @color-primary;
    }
  }
</style>
